export enum FeatureFlagKey {
  ANALYTICS_DASHBOARD = 'ANALYTICS_DASHBOARD',
  QUOTIFY = 'QUOTIFY',
  REMOVE_HUEROTATE = 'REMOVE_HUEROTATE_FIELD_PFM_1722',
  REMOVE_PLAN_EXPIRATION_DATE = 'REMOVE_PLAN_EXPIRATION_DATE_PFM_2126',
  HIDE_ADMIN_EMPLOYEES_NAV = 'HIDE_ADMIN_EMPLOYEES_NAV',
  HIDE_ADMIN_RENEWALS_NAV = 'HIDE_ADMIN_RENEWALS_NAV',
  SPREAD_PLAN_GROUP_ALL_PLANS = 'SPREAD_PLAN_GROUP_ALL_PLANS',
  BENEFIT_POINT_INTEGRATION = 'BENEFIT_POINT_INTEGRATION',
  NEW_WORKBOOK_REVIEW_UI = 'NEW_WORKBOOK_REVIEW_UI',
  BULK_INVITE = 'BULK_INVITE',
  DISABLE_SPREADS_MANAGEMENT = 'DISABLE_SPREADS_MANAGEMENT',
  HIDE_AUTO_BUILD = 'HIDE_AUTO_BUILD',
  REMOVE_DASHBOARD_SUMMARY_WIDGET = 'REMOVE_DASHBOARD_SUMMARY_WIDGET',
}

export interface IFeatureFlag {
  feature: FeatureFlagKey;
  active: boolean;
}

export const FEATURE_FLAGS_CACHE_EXPIRATION = 5 * 60 * 1000;
